export default {
  // Acciones y confirmaciones genericas
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  confirm_data_message: 'You have change your user data. Are you sure you want to continue?',

  // Notificaciones de seguridad (contraseña)
  success_password_changes: 'Your password has been changed. Next time you must login with your new password',

  // Foto de perfil
  change_image: 'Upload new photo',
  biometric: {
    section_title: 'Security',
    title_fingerprint: 'Fingerprint sign-in',
    title_face: 'Face ID sign-in',
    title_generic: 'Biometric sign-in',
    caption_enabled: 'Active on this device',
    caption_disabled: 'Off · turns on next time you sign in with your password',
    caption_dismissed: 'Off · you will not be asked when you sign in with your password',
    reoffer: 'Ask me again',
    reoffer_success: 'We will ask you next time you sign in with your password',
    dialog_title: 'Turn off biometric sign-in?',
    dialog_message: 'Next time you will need to sign in with your username and password on this device.',
    dialog_confirm: 'Turn off',
    disabled_success: 'Biometric sign-in turned off on this device',
    disabled_error: 'Could not turn off biometric sign-in. Please try again.'
  }
}
